import React, { useState, useCallback } from 'react';

const FileDropZone = ({ 
    label, 
    files, 
    onFilesChange, 
    inputId, 
    multiple = false, 
    accept = ".pdf,.docx,.doc,.txt",
    icon = "📁",
    promptMain = "Click anywhere on this section to select files",
    promptTypes = "Supports: .pdf, .docx, .doc, .txt"
}) => {
    const [isDragging, setIsDragging] = useState(false);

    const handleDragOver = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    }, []);

    const handleDragLeave = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    }, []);
    
    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            onFilesChange(Array.from(e.dataTransfer.files));
        }
    }, [onFilesChange]);

    const handleFileChange = (e) => {
        if (e.target.files) {
            onFilesChange(Array.from(e.target.files));
        }
    };

    const removeFile = (indexToRemove) => {
        const newFiles = files.filter((_, index) => index !== indexToRemove);
        onFilesChange(newFiles);
    };

    // Format file size compactly
    const formatFileSize = (bytes) => {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1024 / 1024).toFixed(2) + ' MB';
    };

    // Truncate filename if too long
    const truncateFileName = (name, maxLength = 40) => {
        if (name.length <= maxLength) return name;
        const ext = name.substring(name.lastIndexOf('.'));
        const nameWithoutExt = name.substring(0, name.lastIndexOf('.'));
        return nameWithoutExt.substring(0, maxLength - ext.length - 3) + '...' + ext;
    };

    return (
        <div className="file-drop-zone-container">
            
            <div 
                className={`file-drop-zone ${isDragging ? 'dragging' : ''}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
            >
                <div className="drop-zone-content">
                    <div className="drop-zone-text">
                        <p className="drop-zone-main">{promptMain}</p>
                        <p className="drop-zone-types">{promptTypes}</p>
                    </div>
                    <input
                        type="file"
                        id={inputId}
                        multiple={multiple}
                        accept={accept}
                        onChange={handleFileChange}
                        className="file-input-hidden"
                    />
                </div>
            </div>

            {files.length > 0 && (
                <div className="file-list-compact">
                    <div className="file-items-compact">
                        {files.map((file, index) => (
                            <div key={index} className="file-item-compact">
                                <span className="file-name-compact" title={file.name}>
                                    {truncateFileName(file.name)}
                                </span>
                                <span className="file-size-compact">
                                    {formatFileSize(file.size)}
                                </span>
                                <button
                                    type="button"
                                    className="remove-file-btn-compact"
                                    onClick={(e) => { e.stopPropagation(); removeFile(index); }}
                                    title="Remove file"
                                >
                                    ✕
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default FileDropZone;
